import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "src/components/common";
import { BoardTitle, MiddleTitle } from "../home";

export const SecurityPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Box
        sx={{
          width: "100%%",
          m: "0 auto",
          p: "40px 0 0",
          color: "#000",
          "@media screen and (max-width: 900px)": { padding: "30px 0 0" },
        }}
      >
        <Box
          maxWidth={1200}
          m="0 auto 50px"
          sx={{
            display: "flex",
            justifyContent: "center",
            "@media screen and (max-width: 900px)": {
              mb: "30px",
              "& p": { fontSize: 34 },
            },
          }}
        >
          <BoardTitle arrow="center" isLine>
            <Typography fontSize={50} lineHeight={1.2} letterSpacing={4} fontWeight="bold" textAlign="center" whiteSpace="normal">
              {t("security.title")}
            </Typography>
          </BoardTitle>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: 380,
            background: `url(${require("src/assets/images/chengdu1.jpeg")}) no-repeat center center`,
            backgroundSize: "cover",
            backgroundPosition: "0% 80%",
            opacity: 0.6,
            "@media screen and (max-width: 400px)": {
              height: 300,
            },
          }}
        />
      </Box>
      <Box
        sx={{
          width: "88%",
          maxWidth: 1200,
          height: "auto",
          background: "#fff",
          margin: "0 auto -68px",
          position: "relative",
          top: -68,
          zIndex: 9,
          "@media screen and (max-width: 900px)": {
            top: -38,
            margin: "0 auto -38px",
          },
        }}
      >
        <Box
          sx={{
            width: "85%",
            p: "0 0 80px",
            m: "0 auto",
            "& >.MuiBox-root:first-of-type": {
              height: 68,
              "& p": { lineHeight: "68px" },
            },
            "@media screen and (max-width: 900px)": {
              width: "100%",
              "& >.MuiBox-root:first-of-type": {
                width: "85%",
                m: "0 auto",
              },
              "& >.MuiBox-root:nth-of-type(2)": {
                m: "40px auto 0px",
                "& p": { fontSize: 26 },
              },
            },
          }}
        >
          <MiddleTitle text={t("security.top")} />
          <Box sx={{ display: "flex", justifyContent: "center", m: "70px auto 30px" }}>
            <BoardTitle arrow="center" isLine>
              <Typography fontSize={32} lineHeight={1.2} letterSpacing={4} fontWeight="bold" textAlign="center" whiteSpace="normal">
                {t("security.isms.title")}
              </Typography>
            </BoardTitle>
          </Box>
          <Box sx={{ p: "40px 13% 70px" }}>
            <Typography sx={{ fontSize: "14px", lineHeight: 2.2, fontWeight: "400", whiteSpace: "pre-wrap" }}>
              {t("security.isms.body")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default SecurityPage;
